import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

const HIDE_DELAY_MS = 150;

const InfoTip = ({ text, className = 'ml-1', iconClassName = 'w-3 h-3' }) => {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const iconRef = useRef(null);
  const hideTimerRef = useRef(null);

  const updatePosition = useCallback(() => {
    if (!iconRef.current) return;
    const rect = iconRef.current.getBoundingClientRect();
    setPos({ top: rect.bottom + 4, left: rect.left + rect.width / 2 });
  }, []);

  const open = useCallback(() => {
    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = null;
    }
    updatePosition();
    setShow(true);
  }, [updatePosition]);

  const scheduleClose = useCallback(() => {
    hideTimerRef.current = setTimeout(() => setShow(false), HIDE_DELAY_MS);
  }, []);

  useEffect(() => () => {
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
  }, []);

  if (!text) return null;

  return (
    <span
      className={`inline-flex ${className}`}
      onMouseEnter={open}
      onMouseLeave={scheduleClose}
      onFocus={open}
      onBlur={scheduleClose}
    >
      <svg
        ref={iconRef}
        tabIndex={0}
        role="img"
        aria-label="Info"
        className={`${iconClassName} text-gray-300 hover:text-gray-500 cursor-help transition-colors flex-shrink-0`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
      </svg>
      {show && ReactDOM.createPortal(
        <div
          className="fixed z-[9999] pointer-events-auto"
          style={{ top: pos.top, left: pos.left, transform: 'translateX(-50%)' }}
          onMouseEnter={open}
          onMouseLeave={scheduleClose}
        >
          <div className="-mt-3 pt-3">
            <div className="bg-white border border-gray-100 rounded-lg shadow-lg p-3 min-w-[220px] max-w-[280px]">
              <p className="text-xs text-gray-600 leading-relaxed">{text}</p>
            </div>
          </div>
        </div>,
        document.body
      )}
    </span>
  );
};

export default InfoTip;
